module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Ancient-Assassins-2.dfe6438.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Ancient-Assassins-2.jpg
// module id = gnwo
// module chunks = 0